var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-block"},[_c('div',{staticClass:"form--error error-message"},[_c('div',{staticClass:"error-text error--text"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }